import { RouteLocationNormalized } from 'vue-router';

/** `true` if navigating between the show and season of the same title. */
export function isGoingBetweenShowAndSeason(from: RouteLocationNormalized | null, to: RouteLocationNormalized | null) {
	if (!from || !to) return false;

	// Normalize base show path (with paths like: /us/tv-show/show-name[/season-X])
	const fromShowPath = from.path.split('/').slice(0, 4).join('/');
	const toShowPath = to.path.split('/').slice(0, 4).join('/');

	// Only allow navigations within the same show
	if (fromShowPath !== toShowPath) return false;

	const toSeason = to.name === 'app.detail.show.season';
	const fromSeason = from.name === 'app.detail.show.season';

	// Valid navigations:
	// - season -> show
	// - show -> season
	// - season -> season (same show)
	return (
		(fromSeason && to.name === 'app.detail.show') ||
		(from.name === 'app.detail.show' && toSeason) ||
		(fromSeason && toSeason)
	);
}
